import { configureStore } from '@reduxjs/toolkit';
import user from './reducers/users';
import uisettings from './reducers/uiSettings';
import orders from './reducers/orders';
import site from './reducers/site';

export const store = configureStore({
  reducer: {
    user,
    uisettings,
    orders,
    site,
  },
});
